(function () {
    if (window.hbspt) {
        hbspt.forms.create({
            region: "na1",
            portalId: "9387962",
            formId: "2ff9c2ce-bb98-466e-9e3a-00c380b77294",
            target: "#hubspotForm"
        });
    }
})();
